// FinJourneeCheck.jsx — écran de fin de journée (Lot 2, SPEC_file_locale_v2.md).
// Distinct de ClotureJournee (Lot C, encadrement renforcé) : pas de check-list
// bloquante ni de code de clôture. Rien à signaler → jamais affiché (ce cas est
// géré en silence par DailyPunch, l'appelant). Affiché uniquement quand une
// anomalie est détectée (rapport non confirmé dans la file locale du lot 1, ou
// appartement non pointé) — le salarié ne peut rien réparer lui-même, la seule
// action possible est de prévenir la Direction. Purement présentational :
// l'écriture journal7, la notif et le punch « Fin » sont gérés par DailyPunch.
import React from 'react';

const REASON_LABELS = {
  jamais: 'Jamais pointé',
  nonfini: 'Commencé, jamais pointé fin',
};

export function FinJourneeCheck({ rapports = [], apparts = [], envoye, onEnvoyer, onFermer }) {
  return (<div className="mbk">
    <div style={{ background: 'var(--bg)', borderRadius: 16, padding: 22, maxWidth: 380, width: '100%', margin: '0 14px' }}>
      {!envoye ? <>
        <div style={{ fontSize: 38, textAlign: 'center', marginBottom: 8 }}>⚠️</div>
        <div className="D" style={{ fontSize: 19, textAlign: 'center', color: 'var(--dg)', marginBottom: 4 }}>Avant de partir</div>
        <div style={{ fontSize: 12, color: 'var(--si)', textAlign: 'center', marginBottom: 14 }}>
          Il reste des éléments en suspens aujourd'hui. Tu n'as rien à réparer, mais la Direction doit être prévenue.
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 14 }}>
          {rapports.map(r => (<div key={r.uid} style={{ background: '#fde0e0', border: '1.5px solid var(--dg)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{r.bienName}</div>
            <div style={{ fontSize: 11, color: '#8a0000' }}>Rapport en attente d'envoi depuis {r.since}</div>
          </div>))}
          {apparts.map(a => (<div key={a.id} style={{ background: '#fde0e0', border: '1.5px solid var(--dg)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontWeight: 700, fontSize: 14 }}>{a.bienName}</div>
            <div style={{ fontSize: 11, color: '#8a0000' }}>{REASON_LABELS[a.reason] || 'À vérifier'}</div>
          </div>))}
        </div>
        <button onClick={onEnvoyer} className="btn bok" style={{ width: '100%', padding: '13px', fontSize: 15, fontWeight: 700 }}>Envoyer l'info à la Direction</button>
      </> : <>
        <div style={{ fontSize: 42, textAlign: 'center', marginBottom: 8 }}>✅</div>
        <div className="D" style={{ fontSize: 20, textAlign: 'center', color: 'var(--ok)', marginBottom: 4 }}>Direction prévenue</div>
        <div style={{ fontSize: 12, color: 'var(--si)', textAlign: 'center', marginBottom: 16 }}>Tu peux fermer, ta journée va se terminer normalement.</div>
        <button onClick={onFermer} className="btn bgh" style={{ width: '100%' }}>Fermer</button>
      </>}
    </div>
  </div>);
}
